import axios from '../DashBoardForm';
import apiPaths from '../../helpers/apiPaths';

export default {
  fetch: id => axios.get(apiPaths.design(id)).then(r => r.data),
  request: data => axios.put(apiPaths.designs, data),
  create: data => axios.post(apiPaths.designs, data),
  createOrder: ({ data, designId }) => axios.post(apiPaths.designOrders(designId), data)
};
